module.exports = __webpack_public_path__ + "assets/img/5_1150_big.6d29d982.jpg";